<template>
  <el-dialog
      :visible.sync="visible"
      title="选择合同品番" :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
        v-if="showQuery"
    >
      <el-form-item label="合同编号：">
        <el-input v-model="dataForm.orderCode" size="mini" placeholder="请输入合同编号进行搜索"/>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <SweetTable url="/erp/order/detail/list" ref="table" :is-page="false" :query-form="dataForm" :selection="true"
                :height="500">
      <el-table-column label="外销合同编号" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品番号" prop="product.code" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" prop="product.skuCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="product.color"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="product.size"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="合同数量"
          header-align="center"
          align="center"
      >
      </el-table-column>
    </SweetTable>
    <template slot="footer">
      <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" size="mini">确定选择
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 订单明细选择弹窗组件
 * 使用页面：创建、修改加工单
 */
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  props: {
    showQuery: false,
    exProductIds: ''
  },
  data () {
    return {
      visible: false,
      dataForm: {
        orderCode: '',
        exProductIds: '',
        page: 1,
        limit: 1000000
      },
    }
  },
  watch: {
    exProductIds: {
      handler: function (newVal) {
        this.dataForm.exProductIds = newVal
      },
      immediate: true
    }
  },
  methods: {
    dataFormSubmitHandle () {
      this.$emit('selected', this.$clone(this.$refs.table.dataListSelections))
      this.visible = false
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reload()
      })
    }
  },
}
</script>
